import { createApi } from "@reduxjs/toolkit/query/react";

import { type IApiResponse } from "@/shared/interfaces/api-response.interface";

import customFetchBase from "../custom-fetch-base";

export interface UploadFileResponse {
  id: string;
  url: string;
  filename: string;
  originalName: string;
  mimeType: string;
  size: number;
  isPublic: boolean;
  createdAt: string;
  updatedAt: string;
}

const storageApi = createApi({
  reducerPath: "storageApi",
  baseQuery: customFetchBase,
  tagTypes: [],
  endpoints: (builder) => ({
    uploadFile: builder.mutation<UploadFileResponse, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: "/storage/upload",
          method: "POST",
          body: formData,
        };
      },
      transformResponse: (response: IApiResponse<UploadFileResponse>) => {
        return response.data;
      },
    }),
    deleteFile: builder.mutation<void, string>({
      query: (id) => ({
        url: `/storage/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const { useUploadFileMutation, useDeleteFileMutation } = storageApi;
export default storageApi;
